/**
 * Friendly labels and shared types for plugin setup steps. Lives outside the
 * component file so eslint's `react-refresh/only-export-components` rule
 * stays happy with `SetupStatusBadge.tsx`.
 */
import { isSiteRelativeHref } from '@/lib/site-relative-href';

export { isSiteRelativeHref };

export type SetupStepStatus = 'ok' | 'pending' | 'error';

export type SetupStepKind =
  | 'secret'
  | 'oauth-app'
  | 'github-app'
  | 'webhook-register'
  | 'cli-install'
  | 'external-resource'
  | 'test';

/** Friendly labels for plugin setup step kinds. Shared by wizard and admin. */
export const KIND_LABEL: Record<SetupStepKind, string> = {
  secret: 'Secret',
  'oauth-app': 'OAuth app',
  'github-app': 'GitHub app',
  'webhook-register': 'Webhook',
  'cli-install': 'CLI install',
  'external-resource': 'External resource',
  test: 'Test',
};

/**
 * Site-relative docs hrefs (`/docs/...`) stay inside Reflex. Absolute
 * `https://` URLs leave the product. Both setup-step renderers keep
 * `target="_blank"` so a half-finished wizard is not navigated away;
 * only the ExternalLink icon is dropped for in-app routes. The accessible
 * name still announces the new window, matching nav `openInNewWindow`
 * links.
 */
export function setupStepDocsAccessibleName(label: string, href: string): string | undefined {
  if (!isSiteRelativeHref(href)) return undefined;
  return `${label} (opens in new window)`;
}
